"use strict";

var sortBy = require('lodash/sortBy');

function parseDesignName(title, options) {
  if (!title) {
    throw new Error('title is required');
  }

  var designStyles = options.designStyles;

  if (!designStyles || !Array.isArray(designStyles)) {
    throw new Error('options.designStyles must be an array');
  }

  var design_name = '';
  var matches = designStyles.map(function (_ref) {
    var value = _ref.value;
    return value;
  }).filter(function (value) {
    return title.match(new RegExp(value, 'i'));
  });

  if (matches.length === 1) {
    design_name = matches[0];
  } else if (matches.length > 1) {
    // if we've matched more than one design name, we should
    // console.warn the user, but also return the longest one,
    // since that seems like the most likely true match
    // (e.g. if we match Script and Delicate Elegance Script)
    // it's likely we want to capture the latter.
    design_name = sortBy(matches, 'length').reverse()[0];
    console.warn(title + ' matched more than one design name', matches, 'but chose', design_name);
  }

  return design_name;
}

module.exports = parseDesignName;